import {TokenAPI} from "../api/TokenAPI";

export class TokenService {

    private static instance: TokenService;
    private tokenApi: TokenAPI

    constructor() {
        this.tokenApi = new TokenAPI()
    }

    async verifyToken(token: string): Promise<string> {
        return await this.tokenApi.verifyToken(token)
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new TokenService();
        }
        return this.instance;
    }

}